<template>
    <div class="news-detail-page">
        <section class="news-detail">
            <div class="news-detail-header">
                <!--                <div class="news-detail-title">{{news.title}}</div>-->
            </div>
        </section>

        <div class="news-detail-content" v-html="news.content"></div>
        <!--        <div class="global-back">
            <img src="/static/third/detail_back_btn.svg" @click="$router.back()" alt="">
        </div>-->

        <div class="pre-page">
            <img src="/static/bytx/public/welfare_back_btn.svg" @click="$router.history.go(-1)" />
        </div>
    </div>
</template>

<script>
import Interface from '@/util/interface'

export default {
    name: 'Home',
    data() {
        return {
            news: {},
            meeting: {},

            activeIndex: '',
            handleSelect: false,
            banner: 1,
            swiperOptions: {
                height: 1000,
                autoplay: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                navigation: {
                    nextEl: '.button-next',
                    prevEl: '.button-prev'
                },
                on: {
                    slideChangeTransitionEnd: function() {
                        this.activeIndex
                    }
                }
            },

            //course
            id: '',
            course: {},
            downloads: [],
            related: [],
            value: '',
            active: '',
            tab: 0,
            course_img_visible: true,
            loading: true,
            share_data: {},
            showShareDialog: false,
            htmlUrl: '',
            isShow: false,
            status: '',
            showDownload: false,
            myPlayer: ''
        }
    },
    methods: {
        fetch(scene) {
            if (scene === 'index') {
                Interface.getData('get', Interface.medical.detail + this.id).then(res => {
                    if (res.code == 0) {
                        this.news = res.data
                        Interface.getShareInfo(this, this.news.title, this.news.cover_img, this.news.desc)
                    }
                })
            }
        }
    },
    created() {
        this.id = this.$route.params.id
        this.fetch('index')
    }
}
</script>

<style lang="scss">
@import './detail.scss';
</style>



// WEBPACK FOOTER //
// src/views/medical-services/detail.vue